import React from 'react'

export const Error404 = () => {
  return (
    <div className='error404-container'>
      <h1>Error 404 - Route not found</h1>
    </div>
  )
}
